import { Component, OnInit } from '@angular/core';
import { AdminDashboardService } from 'src/app/services/admin-dashboard.service';
import { NotificationService } from 'src/app/services/notification.service';
import { SideNavBarVisibilityService } from 'src/app/services/side-nav-bar-visibility.service';
import { ZPNotification } from '../../models/zpnotification';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import { ThemeService } from 'src/app/theme/theme-service.service';

@Component({
    selector: 'app-resources',
    templateUrl: './resources.component.html',
    styleUrls: ['./resources.component.scss'],
    standalone: false
})
export class ResourcesComponent implements OnInit {

  public list = [];
  public section = "professionals_config";
  public item: any;
  public itemIsNotSaved: boolean;
  public htmlContent;

  constructor(public sideNavBarVisibilityService: SideNavBarVisibilityService,
    private api: AdminDashboardService,
    private notifications: NotificationService,
    public themeService: ThemeService) {
      this.item = {content: ""}
     }

  async ngOnInit() {
    this.reloadList();
  }

  config: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: '15rem',
    minHeight: '5rem',
    placeholder: 'Enter text here...',
    translate: 'no',
    defaultParagraphSeparator: 'p',
    defaultFontName: 'Arial',
    toolbarHiddenButtons: [
      ['bold']
      ],
  };

  async reloadList() {
    this.list = await this.api.getList(this.section);
    if (this.list.length) {
      this.item = this.list[0]
    }
  }

  async saveItem() {
    this.itemIsNotSaved = true;
    let result = await this.api.putItem(this.section, this.item);
    if (result && result.success) {
      this.itemIsNotSaved = false;
      this.notifications.changeMessage(new ZPNotification("Item Saved"))
      this.reloadList();
    } else {
      this.notifications.changeMessage(new ZPNotification("Save failed"))
    }
  } 
}
